import { defineField, defineType } from "sanity";

export const mailingGroup = defineType({
  name: "mailingGroup",
  title: "Mailing Group",
  type: "document",
  fields: [
    defineField({
      name: "name",
      title: "Group name",
      type: "string",
      description: "Display name for this mailing group (e.g. \"Newsletter\", \"VIP Clients\").",
      validation: (Rule) => Rule.required().error("Give the group a name.")
    }),
    defineField({
      name: "tag",
      title: "Tag",
      type: "slug",
      description: "The tag stored in the Airtable preferences field for subscribers in this group.",
      options: {
        source: "name",
        maxLength: 50
      },
      validation: (Rule) => Rule.required().error("Generate or enter a tag.")
    }),
    defineField({
      name: "description",
      title: "Description",
      type: "text",
      rows: 2,
      description: "Optional description of who belongs in this group."
    })
  ],
  preview: {
    select: {
      title: "name",
      subtitle: "description"
    }
  }
});
